import React, { Component } from 'react';

import { isEmpty } from 'lodash';
import PopUp from '../../../../commonModules/interface/PopUp';

import CurrencyFormat from 'react-currency-format';
import { TableRow, TableCell, Button, TableBody, IconButton } from '@material-ui/core';
import InputText, { InputSelectMagasin } from '../../../../commonModules/interface/form-input-inline';
import { TableLayout } from '../containers/Layout';
import { CloseRounded } from '@material-ui/icons';
import FormArrivage from './FormArrivage';
import ProductLineCell from '../containers/ProductLineCell';
import { toast } from 'react-toastify';
import { generateUniqueId } from '../../../../commonModules/utils/statsFunctions';

class Form extends Component {
    
    state = { 
        // New purchase
        purchase: {
            shop: "",
            shopDisplay: {label: "", value:""},
            nature: this.props.demand ? "demande" : "arrivage",
            transfer_files_req: null,
            transfer_files_BL_req: null,
            transfer_files_BESC_req: null,
            transfer_files_fact_req: null,
            purchase_BL_number: "",
            comments: "",
            estimate_arrival_date: new Date(),
            user_name: "",
            products:[
                {
                    display:{},
                    product_id:"",
                    quantity:"",
                }
            ],
            unique_id: generateUniqueId()
        },
        // errors?
        errors: {
            shop: "",
            nature:"",
            comments: "",
            user_name: "",
            estimate_arrival_date: "",
            user_name: "",
            products:[
                {
                    product_id:"",
                    quantity:"",
                }
            ],
        },
        numberProd: 1,
        view: "form",
        sending: false,
        form: <div></div>  // Liste des produits
    }
    componentDidMount = () => {
        const { arrivage, PRODUCTS } = this.props;
        if (!isEmpty(arrivage)) {

            let numberProd = arrivage.products.length
            let purchase = Object.assign({},arrivage)
            let errors = Object.assign({}, this.state.errors)

            purchase.estimate_arrival_date = new Date(this.props.arrivage.estimate_arrival_date) || new Date()
            purchase.unique_id = generateUniqueId()

            if( PRODUCTS ){
                Object.values(purchase.products).forEach( (product, i) => {   
                    let prodInfo = PRODUCTS[product.product_id]                    
                    purchase.products[i].display = {
                        value: prodInfo.id, 
                        label:`${prodInfo.marque} - ${prodInfo.name}`, 
                        disabled:true
                    } 
                    // purchase.products[i].quantity = parseInt(purchase.products[i].quantity)
                    errors.products[i] = {
                        product_id: "",
                        quantity: "",
                    }

                })
            }

           
            this.setState({
                numberProd,
                purchase,
                errors
            }, () =>{
                // Organise la visualisation des produits
                this.createAddForm()
            }) 
        }
    }
    createProductList = () => {// select product options in Form
        const list = []
        const { PRODUCTS } = this.props
        if( PRODUCTS ){
            Object.values(PRODUCTS).map( product => {   
                let selected = false
                this.state.purchase.products.map( prod  => {   
                    if(prod.product_id  === product.id)   {  // already selected   
                        selected = true 
                    } 
                })
                list.push (       
                    {value:product.id, label:`${product.marque} - ${product.name}`, disabled:selected} 
                )
            })
            return list
        } else {
            return false
        }
    }
    handleSelect = (option, name) => {
        console.log("SELECT HANDLE",{option, name});

        let value = option.value
        let displayName = name +'Display'
        
        this.setState({
            ...this.state,
            purchase:{
                ...this.state.purchase,
                [name]:value,
                [displayName]:option
            }
        }, () =>{
            // Organise la visualisation des produits
            this.createAddForm()
        }) 
    }
    handleSelectProducts = (option, index) => {
        console.log("SELECT HANDLE",{option, index});

        let value = option.value

        let cpProducts = this.state.purchase.products
        cpProducts[index].product_id = value            
        cpProducts[index].display = option

        this.setState({
            ...this.state,
            purchase:{
                ...this.state.purchase,
                products:cpProducts,
            }
        }, () =>{
            // Organise la visualisation des produits
            this.createAddForm()
        }) 
    }
    createAddForm = () => {// form for new product in purchase form
        const tab = []
        const products = this.createProductList()
        const { purchase, errors } = this.state;
        console.log("[INFO] CREATE ADD FORM INDEX ");

        for (let i = 0; i < this.state.numberProd;i++) {
            tab.push(
                <TableRow key={i}>
                    <ProductLineCell
                        numberProd={this.state.numberProd}
                        handleDeleteProd={() => this.handleDeleteProd(i)}
                        options={products}
                        value={purchase.products[i].display || {value:"", label:""}}
                        error={errors.products[i].product_id}
                        onChange={ option => this.handleSelectProducts(option,i)}
                    />
                    <TableCell>
                        <InputText 
                            type="number" 
                            min={1} 
                            step={10} 
                            onChange={this.handleChange} 
                            value={purchase.products[i].quantity} 
                            name={"prod_-quantity-"+i} 
                            placeholder="Quantité"
                            label="Quantité"
                            error={errors.products[i].quantity}
                        />
                    </TableCell>                            
                </TableRow>
            )
        }
        this.setState({
            ...this.state,
            form:tab,
        })
        return tab;
    }
    handleAddProd = () => {// add new line in the form to add a product to the purchase
        const shop_id = this.state.purchase.shop
        if (shop_id === "" || typeof shop_id === "undefined"){
            toast.error("Shop must be selected")
            return
        }
        this.setState({
            ...this.state,
            purchase:{
                ...this.state.purchase,
                products:[
                    ...this.state.purchase.products,{
                    display:{},
                    product_id:"",
                    quantity:"",
                }]
            },
            errors:{
                ...this.state.errors,
                products:[
                    ...this.state.errors.products,{
                    product_id:"",
                    quantity:"",
                    
                }]
            },
            numberProd:this.state.numberProd + 1,
        }, () =>{
            // Organise la visualisation des produits
            this.createAddForm()
        }) 
    }
    handleAddProdByCSV = (productList) =>{
        console.log("Form purchase F  ,handleAddProdByCSV,",productList)
        const productListLocal = new Array();
        const productListLocalErr = new Array();
        const shop_id = this.state.purchase.shop
        if (shop_id === ""|| typeof shop_id === "undefined"){
            toast.error("Shop must be selected")
            return
        }
        let nbOfProduct = 0;

        productList.forEach((value, key)=>{
            console.log("Form purchase F ,handleAddProdByCSV,",value[5],value[4])
            if (!value[4]){
                return
            }
            nbOfProduct++
             const productEntry = {
                display: {value:value[5].id,label:value[0]},
                product_id: value[5].id,
                quantity: value[2]
              };
            const productEntryErr = {                      
                product_id:"",
                quantity:"",
            };
            productListLocal.push(productEntry);
            productListLocalErr.push(productEntryErr);
        })
        console.log("Form purchase ,handleAddProdByCSV,productListLocal",productListLocal)
        if (productListLocal.length > 0){
            console.log("Form purchase ,handleAddProdByCSV,Add product",productListLocal.length)
            this.setState({
                ...this.state,
                purchase:{
                    ...this.state.purchase,
                    products:[...productListLocal]
                },
                errors:{
                    ...this.state.errors,
                    products:[...productListLocalErr]
                },
                numberProd:nbOfProduct,
            }, () =>{
                this.createAddForm()
            })  
        }
        toast.info( "Importation réussi de "+nbOfProduct+" produits")
    }

    handleDeleteProd = (index) => {// delete line in the form to add a product to the purchase
        this.setState({
            ...this.state,
            purchase:{
                ...this.state.purchase,
                products:[
                    ...this.state.purchase.products.slice(0,index),
                    ...this.state.purchase.products.slice(index +1),
                ]
            },
            errors:{
                ...this.state.errors,
                products:[
                    ...this.state.errors.products.slice(0,index),
                    ...this.state.errors.products.slice(index +1),   
                ]
            },
            numberProd:this.state.numberProd-1,
        }, () =>{
            // Organise la visualisation des produits
            this.createAddForm()
        })    
    }

    handleChange = async  (e) => {  
        const field = e.target.name
        const value = e.target.value

        const regex = /^[0-9\b]+$/ // int only

        console.log({field, value})
        let purchaseUpdate = Object.assign({}, this.state.purchase)

        
        if(field.startsWith("prod_")){
            // field = "prod_-quantity-4" || "prod_-product_id-4"

            let splitTab = field.split("-")
            let name = splitTab[1]
            let index = splitTab[2]
            console.log("[INFO] INDEX field", splitTab, splitTab[0], splitTab[1]);
            // let cpProducts = this.state.purchase.products
            if(name === "quantity") {
                if(value ==="" || regex.test(value)){// update value only if its a int
                    purchaseUpdate.products[index][name] = value
                }
            } else {
                purchaseUpdate.products[index][name] = value
            }
        } else {
            purchaseUpdate[field] = value
        }
        this.setState({
            ...this.state,
            purchase: purchaseUpdate
        }, () =>{
            // Organise la visualisation des produits
            this.createAddForm()
        }) 
    }
    handleChangeDate = (selectedDate) => {
        console.log("IN HANDLE CHANGE date", selectedDate);
        
        this.setState({
            ...this.state,
            purchase:{
                ...this.state.purchase,
                estimate_arrival_date: selectedDate,

            }
        }, () =>{
            // Organise la visualisation des produits
            this.createAddForm()
        }) 
    }
   
    setFiles = (list, file_type) => {
        console.log("[INFO] SETFILES", list, file_type);
        
        this.setState({
            ...this.state,
            purchase:{
                ...this.state.purchase,
                [file_type]:list
            }
        })
    }
    
    validate = () => {// checks if no error in form before sending it to Back
        let noErrors = true
        let errors = Object.assign({}, this.state.errors)
        let data = Object.assign({}, this.state.purchase)

        Object.keys(data).map( field => {
            if((data[field] === "" || data[field] === [] ) && field != "purchase_BL_number"){// input is empty  
                noErrors = false
                errors[field] = "Veuillez remplir ce champ"
                    
            } else if(field === "products") {
                data.products.forEach((item, j) => {
                    Object.keys(item).map( field2 => { // field2 product_id || quantity
                        console.log('====================================');
                        console.log({item, field2, value: item[field2]});
                        console.log('====================================');
                        const val = item[field2]
                        if (typeof val === 'number' && !isNaN(val) && val !== 0) {
                                errors.products[j][field2] = ""
                        }else{
                            if( isEmpty(val) || val === 0 ){
                                console.log("[ERROR],",field2,"-",item,">>",item[field2],"type",typeof val)
                                noErrors = false
                                errors.products[j][field2] = "Veuillez remplir ce champ"
                            } else {
                                errors.products[j][field2] = ""
                            }
                        }
                    })
                })
            } else { // not empty
                errors[field] = ""   
            }
        })
        console.log("[INFO] NOERRORS = ",noErrors);
        console.log("[INFO] VALIDATE, ERRORS = ",errors);
        
        this.setState({
            // ...this.state,
            errors
        }, () =>{
            // Organise la visualisation des produits
            this.createAddForm()
        }) 
        if (noErrors) {
            
            this.setState({ view: "confirm" })
        } else {
            toast.error( "Le formulaire contient des erreurs")
        }
    }


    validateUpdate = () => {// checks if no error in form before sending it to Back
        let noErrors = true
        let errors = Object.assign({}, this.state.errors)
        let data = Object.assign({}, this.state.purchase)
        let requiredProd = ["product_id", "quantity" ]

        Object.keys(errors).map( field => {
            if(data[field] === "" || data[field] === [] ){// input is empty  
                noErrors = false
                errors[field] = "Veuillez remplir ce champ"
                    
            } else if(field === "products") {
                data.products.forEach((item, j) => {
                    requiredProd.map( field2 => { // field2 product_id || quantity
                        console.log('====================================');
                        console.log({item, field2, value: item[field2]});
                        console.log('====================================');
                        if( !item[field2] || 
                            item[field2] === 0 || 
                            item[field2] === "0" 
                        ){
                            noErrors = false
                            errors.products[j][field2] = "Veuillez remplir ce champ"
                        } else {
                            errors.products[j][field2] = ""
                        }
                    })
                })
            } else { // not empty
                errors[field] = ""   
            }
        })
        console.log("[INFO] NOERRORS = ",noErrors);
        console.log("[INFO] VALIDATE, ERRORS = ",errors);
        
        this.setState({
            // ...this.state,
            errors
        }, () =>{
            // Organise la visualisation des produits
            this.createAddForm()
        }) 
        if (noErrors) {
            
            this.setState({ view: "confirm" })
        } else {
            toast.error( "Le formulaire contient des erreurs")
        }
    }

    handleSubmit = async () => {
        const purchase = Object.assign({}, this.state.purchase)
        this.setState({
            sending: true,
        }, async () =>{
            // purchase.id = ""        
            purchase.shop_id = purchase.shop
            // purchase.transfer_files_req =  purchase.transfer_files
            // purchase.transfer_files_BESC_req =  purchase.transfer_files_BESC
            // purchase.transfer_files_fact_req =  purchase.transfer_files_fact
            // purchase.transfer_files_BL_req =  purchase.transfer_files_BL

            for (let i = 0; i < purchase.products.length; i++){
                purchase.products[i].quantity = parseInt(purchase.products[i].quantity)
            }

        if ( this.props.demand){
            await this.props.createDemand(purchase)
            if(this.props.STATE.demands.error){
                console.log("ERROR", this.props.STATE.demands.error);
                this.setState({
                        sending: false,
                    })
                toast.error( this.props.STATE.demands.error)
            } else{
                console.log("fetched");
                toast.info("L'opération a été enregistré avec succès")
                this.handleClose()
            }
            } else {
            await this.props.createArrivage(purchase)

            if(this.props.STATE.arrivages.error){
                console.log("ERROR", this.props.STATE.arrivages.error);
                this.setState({
                        sending: false,
                    })
                toast.error( this.props.STATE.arrivages.error)
            } else{
                console.log("fetched");
                this.setState({
                        sending: false,
                    })
                toast.info("L'opération a été enregistré avec succès")
                this.handleClose()
            }
        }
        }) 
    }

    handleSubmitUpdate = async () => {
        const { arrivageOLD } = this.props;
        const purchase = Object.assign({}, this.state.purchase)

        purchase.shop_id = purchase.shop
        // purchase.unique_id = this.state.unique_id --> CDM

        if (arrivageOLD &&!this.props.demand) {
            purchase.transfer_files = arrivageOLD.transfer_files 
            purchase.transfer_files_BESC = arrivageOLD.transfer_files_BESC 
            purchase.transfer_files_fact = arrivageOLD.transfer_files_fact 
            purchase.transfer_files_BL = arrivageOLD.transfer_files_BL 
        }

        // purchase.update_date = new Date()

        for (let i = 0; i < purchase.products.length; i++){
            purchase.products[i].quantity = parseInt(purchase.products[i].quantity)
        }

        if (this.props.demand){
            console.log("Update new demande >> handleSubmitUpdate")
            const resp = await this.props.createDemand(purchase,true)
            if(this.props.STATE.demands.error){
                console.log("ERROR", this.props.STATE.demands.error);
                this.setState({
                        sending: false,
                    })
                toast.error( this.props.STATE.demands.error)
            } else{
                console.log("fetched");
                toast.info("L'opération a été enregistré avec succès")
                this.handleClose()
            }
        }else{
            await this.props.updateArrivage(purchase)

            if(this.props.STATE.arrivages.error){
                console.log("ERROR", this.props.STATE.arrivages.error);
                
                toast.error( this.props.STATE.arrivages.error)
            } else{
                console.log("fetched");
                toast.info("L'arrivage a été modifié avec succès")
                this.handleClose()
            }
        }
    }

    handleClose = () => {
        console.log('====================================');
        console.log("HANDLE CLOSE");
        console.log('====================================');
        this.props.handleClose()
    }
    
    render() {
        const { purchase, view } = this.state;
        const { arrivageOLD } = this.props;
        console.log('====================================');
        console.log({purchase});
        console.log('====================================');
        let fieldList = []
        if (this.state.view === "confirm" ) {
            fieldList = [
                {name: "nature", label:"Nature", display: purchase.nature },
                {name: "shop", label:"Magasin", display: purchase.shopDisplay.label },
                {name: "transfer_files", label:"Autres", display: 
                    (purchase.transfer_files ? purchase.transfer_files.map(file => (file.filename)).join(" | ") : 
                        (arrivageOLD && arrivageOLD.transfer_files ? arrivageOLD.transfer_files.map(file => (file.filename)).join(" | ") : "") 
                ) },
                {name:"space"},
                {name:"products"},  
                {name: "user_name", label:"Demandeur", display: purchase.user_name },
                {name: "comments", label:"Commentaire", display: purchase.comments },
                
                {name: "estimate_arrival_date", label:"Date d'arrivée", display: purchase.estimate_arrival_date.toLocaleDateString("fr-FR")}
            ]

            if (!this.props.demand){
                fieldList.push({name: "transfer_files_BL", label:"BL", display: (
                    purchase.transfer_files_BL ? purchase.transfer_files_BL.map(file => (file.filename)).join(" | ") : 
                        (arrivageOLD && arrivageOLD.transfer_files_BL ? arrivageOLD.transfer_files_BL.map(file => (file.filename)).join(" | ") : "")
                )}, 
                {name: "transfer_filesBESC", label:"BESC", display: (
                    purchase.transfer_files_BESC ? purchase.transfer_files_BESC.map(file => (file.filename)).join(" | ") : 
                        (arrivageOLD && arrivageOLD.transfer_files_BESC ? arrivageOLD.transfer_files_BESC.map(file => (file.filename)).join(" | ") : "") ) 
                },
                {name: "transfer_files_fact", label:"Facture", display: 
                    (purchase.transfer_files_fact ? purchase.transfer_files_fact.map(file => (file.filename)).join(" | ") : 
                        (arrivageOLD && arrivageOLD.transfer_files_fact ? arrivageOLD.transfer_files_fact.map(file => (file.filename)).join(" | ") : "") 
                ) },
                {name: "purchase_BL_number", label:"Numero de suivi", display: purchase.purchase_BL_number },
                )
            }
        }
       console.log('=============PROPS=======================');
       console.log(this.props);
       console.log('====================================');
        return (
            <div>
                {view === "form" &&
                    <FormArrivage 
                        {...this.state} 
                        {...this.props}
                        total={this.total}
                        createAddForm={this.state.form}
                        handleAddProd={this.handleAddProd}
                        handleAddProdByCSV={this.handleAddProdByCSV}
                        handleSelect={this.handleSelect}
                        handleChange={this.handleChange}
                        handleChangeDate={this.handleChangeDate}
                        setFiles={this.setFiles}
                        handleCheck={value => this.setState({
                            ...this.state, 
                            purchase: {
                                ...this.state.purchase, 
                                received: value
                            } 
                        })}
                        validate={this.props.update ? this.validateUpdate : this.validate}
                        handleSubmit={this.props.update ? this.validateUpdate : this.validate}
                        handleClose={this.handleClose}
                    />
                }
                {view === "confirm" &&
                    <PopUp 
                        title="Résumé" 
                        close={() => this.setState({view: "form"})}
                        submitAction={ this.props.update ? this.handleSubmitUpdate : this.handleSubmit }
                        disabledSubmit={this.props.STATE.arrivages.fetching || this.state.sending}
                    >
                        <TableLayout>
                            <TableBody>
                            
                            {fieldList.map( field => {
                                if (field.name === "products"){
                                    return (
                                        <React.Fragment>
                                            <TableRow>
                                                <TableCell rowSpan={ purchase.products.length + 1 }>Produits</TableCell>
                                                <TableCell>Nom</TableCell>
                                                <TableCell>Quantité</TableCell>
                                            </TableRow>
                                            {purchase.products.map( prod => (
                                                <TableRow style={{backgroundColor:"lightyellow"}}>
                                                    <TableCell style={{width:"400px"}}>{prod.display.label}</TableCell>
                                                    <TableCell><b>{prod.quantity}</b></TableCell>
                                                </TableRow>
                                                )
                                            )}
                                        </React.Fragment>
                                    )
                                } else if (field.name === "space"){
                                    return <TableRow><TableCell colSpan={4}></TableCell></TableRow>
                                } else {
                                    return (
                                        <TableRow>
                                            <TableCell>{field.label}</TableCell>
                                            <TableCell >{field.display}</TableCell>
                                            <TableCell colSpan={2}></TableCell>
                                        </TableRow>
                                    )
                                }
                            })

                            }                            
                            </TableBody>
                        </TableLayout>
                    </PopUp>
                }
            </div>
                
        );
    }
}

export default Form;